export default __webpack_public_path__ + "static/media/Silvopasture_Aerial_timber_After2.cc7a8008.jpg";